export const LOADING_DISCIPLINARY_ACTIONS = "LOADING_DISCIPLINARY_ACTIONS";
export const SAVE_LOADING_DISCIPLINARY_ACTIONS = "SAVE_LOADING_DISCIPLINARY_ACTIONS";
export const GET_DISCIPLINARY_ACTIONS = "GET_DISCIPLINARY_ACTIONS";
export const FORM_FAIL = "FORM_FAIL";
export const DISCIPLINARY_ACTIONS_FAIL = "DISCIPLINARY_ACTIONS_FAIL";
export const EMAIL_ERROR = "EMAIL_ERROR";
export const LOADING_EMAIL_SEND = "LOADING_EMAIL_SEND";

